import config from 'admin-panel/config/environment';

export default async function uploadTvChannelLogo(
  auth: string,
  tvChannelId: string,
  title: string,
  file: File
) {
  const { host, namespace } = config.api;

  const url = `${host}/${namespace}/room_control/tv_channels/${tvChannelId}`;
  const formData = new FormData();

  formData.set('room_control/tv_channel[title]', title);
  formData.set('room_control/tv_channel[logo]', file, file.name);

  const response = await fetch(url, {
    method: 'PATCH',
    headers: {
      Authorization: auth,
    },
    body: formData,
  });

  if (!response.ok) {
    throw new Error('Logo upload failed');
  }

  return response.json();
}
